import * as React from 'react';
import * as DOMPurify from 'dompurify';

type SafeInjectHtmlProps<K extends keyof JSX.IntrinsicElements> = JSX.IntrinsicElements[K] & { tag: K; html: string };

type CleanedHtmlComponent = <K extends keyof JSX.IntrinsicElements>(props: SafeInjectHtmlProps<K>) => JSX.Element;

function makePurifyComponent(sanitize: boolean): CleanedHtmlComponent {
  const getHtml = sanitize
    ? (html: string) => React.useMemo(() => DOMPurify.sanitize(html), [html])
    : (html: string) => html;

  const Component = React.forwardRef<any, any>((props, ref) => {
    const { tag, html, ...rest } = props;

    const __html = getHtml(html);

    return React.createElement(tag, {
      ...rest,
      ref,
      //eslint-disable-next-line no-useless-concat
      ['dangerously' + 'SetInnerHTML']: { __html },
    });
  });
  Component.displayName = sanitize ? 'SafeInjectHtml' : 'ImSureInputIsSafeInjectHtml';
  return Component as CleanedHtmlComponent;
}

// use it only when you 100% sure input is sanitized AND SafeInjectHtml is breaking html
// for 99% of cases, use SafeInjectHtml instead
export const ImSureInputIsSafeInjectHtml = makePurifyComponent(false);

export const SafeInjectHtml = makePurifyComponent(true);
